export default "__VITE_ASSET__wIllckfZ__"